import {
    createSlice,
    PayloadAction
} from '@reduxjs/toolkit'

export interface Store {
    id: number,
    alias_id?: number | null,
    stores_address?: string,
    store_lat: number,
    store_long: number,
    store_name: string,
    store_services: Array<number>
    store_services_addons: Array<any>
}

type Flavour = 'default' | 'podepay' | 'boticario'
var flavour: Flavour = window.location.href.includes('podepay.painelalter.com') ? 'podepay' :
    window.location.href.includes('boticario.painelalter.com') ? 'boticario' : 'default';
// flavour="boticario"

interface sessionState {
    stores: Array<Store>
    userActivity?: any
    username: string
    sessionId?: number
    flavour: Flavour,
    storeSelected: Store | undefined
}

const initialSessionState = {
    stores: [],
    userActivity: {},
    username: "",
    flavour: flavour,
    storeSelected: undefined
} as sessionState;

// TODO: Implement it widely
export const sessionSlice = createSlice({
    name: 'session',
    initialState: initialSessionState,
    reducers: {
        setStores: (state, action: PayloadAction<Array<Store>>) => {
            state.stores = action.payload;
        },
        setUserActivity: (state, action: PayloadAction<any>) => {
            state.userActivity = action.payload;
        },
        setUsername: (state, action: PayloadAction<string>) => {
            state.username = action.payload;
        },
        setSessionId: (state, action: PayloadAction<number>) => {
            state.sessionId = action.payload;
        },
        setStoreSelected: (state, action: PayloadAction<Store | undefined>) =>{
            state.storeSelected = action.payload
        }
    },
})

export const { setStores, setUserActivity, setUsername, setSessionId, setStoreSelected } = sessionSlice.actions;
export default sessionSlice.reducer;
